import Parallax from "parallax-js";
import "slick-carousel/slick/slick";
import Accordion from "@/modules/containers/accordion";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import contactForm from "@/modules/blocks/contact-form/index";
import modalShow from "@/modules/containers/modal/modal";

const animateFormClass = ".js-ready-animate-form";
let animateWasPlayedFlag = false;

const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene[0], {
    pointerEvents: false,
    invertX: false,
    invertY: false,
    relativeInput: false
  });
  parallaxInstance.friction(0.2, 0.2);
};

const initParallaxMobile = () => {
  const tabletBreakpoint = 960;
  if ($(window).width() > tabletBreakpoint) {
    const scene = $(".js-decorations-key-group");
    $(scene).each(function() {
      initParallaxDecorations($(this));
    });
  }
};

const elToScroll = () => {
  $(".js-learn-more").on("click", function(e) {
    const href = $(this).attr("href");

    if (href == "#form-user-data") {
      e.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($(this).attr("href")).offset().top - 168
        },
        500,
        "linear"
      );

      $("#focus-element").focus();
    }
  });
};

const initWorkflowSlider = () => {
  const slickElement = $(".js-efficiency-slider-viewport"),
    status = $(".js-slide-counter"),
    nextArrow = $(".js-slider-arrow .btn-next-arrow"),
    prevArrow = $(".js-slider-arrow .btn-prev-arrow"),
    sliderSingle = $(".js-efficiency-slider-viewport"),
    showMoreDescriptionLink = $(".workflows-details__link"),
    showMoreDescription = $(".workflows-details__description"),
    moreText = "Read more",
    lessText = "Read less";

  slickElement.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (sumCouner < 10) {
      status.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;0" + sumCouner);
    } else if (counter < 10) {
      status.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    } else {
      status.html("<b>" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    }

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      nextArrow.addClass("is-disable");
      nextArrow.attr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    } else {
      nextArrow.removeClass("is-disable");
      nextArrow.removeAttr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    }
  });

  slickElement.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 300,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    dsf: false,
    fade: true,
    dots: true,
    responsive: [
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          adaptiveHeight: true,
          centerMode: false
        }
      }
    ]
  });

  slickElement.on("afterChange", function() {
    $(".workflows-illustration").css("display", "block");
    $(showMoreDescription).removeClass("is-open");
    $(showMoreDescriptionLink).removeClass("less");
    $(showMoreDescriptionLink).html(moreText);
    $(".slick-list").removeClass("is-open");

    if ($(window).width() >= 960) {
      $(".slider-nav").css(
        "top",
        $(".slick-active .efficiency-slide__summary").outerHeight(true)
      );
    }
  });

  slickElement.on("beforeChange", function() {
    $(".workflows-illustration").css("display", "none");
  });

  $(".slick-list").attr("aria-live", "polite");

  nextArrow.click(function(e) {
    sliderSingle.slick("slickNext");
  });
  prevArrow.click(function(e) {
    sliderSingle.slick("slickPrev");
  });

  // ShowText
  $(showMoreDescriptionLink).click(function(e) {
    e.preventDefault();
    $(this)
      .prev(showMoreDescription)
      .toggleClass("is-open");

    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(moreText);
      $(".slick-list").removeClass("is-open");
    } else {
      $(this).addClass("less");
      $(this).html(lessText);
      $(".slick-list").addClass("is-open");
    }
  });

  const resetOpenedText = () => {
    $(".slider-nav").css("width", $(".workflows-illustration").width());
    $(".slider-nav").css(
      "top",
      $(".dynamic-workflows__column--illustations").outerHeight(true)
    );
  };
};

const inView = function(element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const startAnimation = () => {
  const animateForm = document.querySelector(animateFormClass);

  if (animateForm !== null) {
    window.addEventListener("scroll", event => {
      if (inView($(animateForm))) {
        $(".form-wrapper").addClass("animate-form-visible");
      }
    });
  }
};

$(document).ready(function() {
  Accordion();
  initParallaxMobile();
  initWorkflowSlider();
  elToScroll();
  startAnimation();
  addedLazyLoadImages();
  initWowLibrary();
  contactForm();
  modalShow();
});
